import React, { Component } from "react";
import { Redirect } from "react-router";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { COLOR_WHITE } from "../common/constants";
import Typography from "../common/Typography";
import { max } from "../common/Media";
import data from "./data";
import { HTTP } from "../../apiConfig";

const propTypes = {
  match: PropTypes.object.isRequired,
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const StyledH2 = Typography.withComponent("h2").extend`
  font-size: 40px;
`;

const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
  margin: 8px;
  text-align: center;

  ${max.xs`
    margin: 6px;
  `};
`;

const StyledCard = styled.div`
  width: 200px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 16px 0px rgba(43, 85, 162, 0.11);
  background-color: ${COLOR_WHITE};
  transition: 0.15s box-shadow;
  border-radius: 4px;

  &:hover {
    box-shadow: 0px 2px 10px 0px rgba(43, 85, 162, 0.3);
  }

  ${max.xs`
    width: 45vw;
  `};
`;

class Jurisdictions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }

  componentDidMount() {
    const { productGuidOrCompanyId } = this.props.match.params;

    if (!Number.isNaN(Number(productGuidOrCompanyId))) {
      HTTP.get(
        `/forms/getCompanyToProductRedirectUrl/${productGuidOrCompanyId}/`,
        { params: { jurisdictionCode: "" } }
      ).then((response) => {
        if (response.status === 200) {
          this.setState({ redirect: true, data: response.data });
        }
      });
    }
  }

  renderContent() {
    return Number.isNaN(
      Number(this.props.match.params.productGuidOrCompanyId)
    ) ? (
      <Container>
        {data.map((o) => (
          <StyledLink
            to={`/${this.props.match.params.productGuidOrCompanyId}/${o.code}`}
            key={o.code}
          >
            <StyledCard>
              <Typography primary>{o.name}</Typography>
            </StyledCard>
          </StyledLink>
        ))}
      </Container>
    ) : (
      <StyledFlex justify="center" align="center" flex="1">
        <StyledH2 grey>No content available</StyledH2>
      </StyledFlex>
    );
  }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{ pathname: this.state.data.redirectUrl, state: { status: 301 } }}
        />
      );
    }

    return this.renderContent();
  }
}

Jurisdictions.propTypes = propTypes;
export default Jurisdictions;
